/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import { createBrowserHistory } from 'history'
export let history = createBrowserHistory()
